function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function getMetaTagContent(metaTagName) {
  const metas = document.getElementsByTagName("meta");

  for (let i = 0; i < metas.length; i++) {
    if (metas[i].getAttribute("name") === metaTagName) {
      return metas[i].getAttribute("content");
    }
  }

  return "";
}

function generateId() {
  // Math.random should be unique because of its seeding algorithm.
  // Convert it to base 36 (numbers + letters), and grab the first 9 characters
  // after the decimal.
  return Math.random().toString(36).substr(2, 9);
};

function publicId() {
  return window.location.pathname.match(/\/s\/([^\/]+)\/*/) != null 
    ? window.location.pathname.match(/\/s\/([^\/]+)\/*/)[1] 
    : null;
}

function isMobile() {
  return window.matchMedia("only screen and (max-width: 991px)").matches;
}

// Determines if the passed element is overflowing its bounds,
// either vertically or horizontally.
// Will temporarily modify the "overflow" style to detect this
// if necessary.
function isOverflowing(el)
{
   var curOverflow = el.style.overflow;

   if ( !curOverflow || curOverflow === "visible" )
      el.style.overflow = "hidden";

   var isOverflowing = el.clientWidth < el.scrollWidth 
      || el.clientHeight < el.scrollHeight;

   el.style.overflow = curOverflow;

   return isOverflowing;
}

// Key can either be a string representing the top level key in a form field's
// name, or a function accepting an attribute name and returning a selector
// Also, return null for a key to ignore it and handle it separately.
function renderErrors(form, data, selector) {
  const json = data.responseJSON;
  const errors = json.errors;
  Object.keys(errors).forEach(function(attribute) {
    let computedSelector;
    if(typeof selector == "function") {
      computedSelector = selector(attribute, errors);
    } else {
      computedSelector = `[name='${selector}[${attribute}]']`;
    }
    if(computedSelector != null) {
      $(form).find(computedSelector).addClass("is-invalid").wrap(`<div class="has-danger" />`);
    }
  });
}

function scrollToEl(el, offset) {
  offset = offset || 0

  if($(el).length) {
    $([document.documentElement, document.body]).animate({
      scrollTop: $(el).offset().top - $("nav.navbar-horizontal").height() - offset
    }, 500);
  }
}

function scrollToTop() {
  $([document.documentElement, document.body]).animate({
    scrollTop: 0
  }, 500);
}

function getItem(key) {
  return localStorage.getItem(key);
}

function setItem(key, value) {
  localStorage.setItem(key, value)
}

function urlParam(name, url) {
  if (!url) url = location.href;
  name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
  let regexS = "[\\?&]"+name+"=([^&#]*)";
  let regex = new RegExp(regexS);
  let results = regex.exec(url);
  return results == null ? null : results[1];
}

// Expose functions globally for inline scripts
window.capitalizeFirstLetter = capitalizeFirstLetter;
window.getMetaTagContent = getMetaTagContent;
window.generateId = generateId;
window.publicId = publicId;
window.isMobile = isMobile;
window.isOverflowing = isOverflowing;
window.renderErrors = renderErrors;
window.scrollToEl = scrollToEl;
window.scrollToTop = scrollToTop;
window.getItem = getItem;
window.setItem = setItem;
window.urlParam = urlParam;